import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Badge from '@material-ui/core/Badge';
import styled from 'styled-components';
import { colors } from '../../../constants/colors';
import { fontFamily, fontSize } from '../../../constants/text';
import { smallerThan } from '../../../core/util/styledComponents';
import { VIEW_CONFIG } from '../../Account/util/views';

const StyledTabs = styled(Tabs)`
  & .label {
    font-size: ${fontSize.default};
    font-family: ${fontFamily.medium};
    font-weight: unset;
    color: ${colors.lightText};
    text-transform: capitalize;
  }

  & .tabSelected {
    & .label {
      color: ${colors.squid};
    }
  }

  & .tabRoot {
    min-width: 100px;
    padding-bottom: 32px;
  }

  & .mobileTabsBadge {
    font-size: 9px;
    min-width: 14px;
    border-radius: 8px;
    padding: 0 1px 1px 0;
    background-color: ${colors.crunchBerry};
    top: 8px;
    right: 16px;
    height: 14px;
  }

  ${smallerThan.tablet`
    & .label {
      font-size: ${fontSize.mediumSmall};
    }
    & .tabRoot {
      min-width: 80px;
    }
  `}

  & .indicator {
    background-color: ${colors.crunchBerry};
    height: 3px;
  }

  & .flexContainer {
    justify-content: space-between;
    background: ${colors.whiteGrey};
  }

  & .root {
    @media (min-width: 960px) {
    }
  }

  & .tabRoot {
    opacity: 1;
  }

  & .labelContainer {
    padding-bottom: 0;
  }
`;

class MobileTabs extends Component {
  static propTypes = {
    selectedTabId: PropTypes.string.isRequired,
    tabProperties: PropTypes.array.isRequired,
  };

  render() {
    return (
      <StyledTabs
        value={this.props.selectedTabId || false}
        classes={{
          indicator: 'indicator',
          flexContainer: 'flexContainer',
          root: 'root',
        }}
      >
        {this.props.tabProperties.map(props => {
          const tab = (
            <Tab
              key={props.view}
              label={VIEW_CONFIG[props.view].navLabel}
              value={props.view}
              onClick={props.onClick}
              classes={{
                selected: 'tabSelected',
                label: 'label',
                root: 'tabRoot',
              }}
            />
          );

          if (props.badge) {
            return (
              <Badge
                badgeContent={props.badge}
                color="primary"
                classes={{ badge: 'mobileTabsBadge' }}
              >
                {tab}
              </Badge>
            );
          }

          return tab;
        })}
      </StyledTabs>
    );
  }
}

export default MobileTabs;
